import { makeStyles } from '@material-ui/core/styles';

const headerHeight = 60;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100%',
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: '0px 3px 6px #00000029',
    color: theme.palette.common.white,
    height: headerHeight,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '100%',
  },
  toolbar: {
    minHeight: headerHeight,
  },
  locoContainer: {
    marginLeft: 16,
    marginRight: 60,
  },
  logo: {
    width: 144,
  },
  name: {
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(13),
  },
  divider: {
    height: 30,
    margin: 'auto 0.5rem auto 0.75rem',
  },
  notificationsIcon: {
    color: theme.palette.common.white,
  },
  notification: {
    color: theme.palette.common.white,
  },
  date: {
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(13),
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    maxWidth: '100%',
    'overflow-y': 'hidden',
    padding: `${theme.spacing(10.75)}px ${theme.spacing(3)}px ${theme.spacing(5)}px`,
  },

  select: {
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(13),
    paddingTop: 0,
    '&::before': {
      borderWidth: 0,
    },
    '&::after': {
      borderWidth: 0,
    },
    '&:hover': {
      '&::before': {
        borderWidth: '0 !important',
      },
    },
    '& .MuiSelect-root': {
      paddingRight: 34,
    },
    '& .MuiSelect-icon': {
      color: theme.palette.common.white,
    },
  },
}));

export default useStyles;
